import { render, staticRenderFns } from "./SocialNetworkButton.vue?vue&type=template&id=1b6e2aaa&scoped=true"
import script from "./SocialNetworkButton.vue?vue&type=script&lang=js"
export * from "./SocialNetworkButton.vue?vue&type=script&lang=js"
import style0 from "./SocialNetworkButton.vue?vue&type=style&index=0&id=1b6e2aaa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b6e2aaa",
  null
  
)

export default component.exports